//develop
// const USER= 'https://i.reflower.com.cn/api/user/getUserInfo';
// const UPLOAD = 'https://i.reflower.com.cn/order/file/image/upload'
// const servicePage = 'https://i.reflower.com.cn/api/user/community/getpage'
// const loginurl = 'https://my.reflower.com.cn/login/tologin?redirecturi='
// const getdetail = 'https://i.reflower.com.cn/api/user/community/getdetail'
//product
//const USER= 'https://i.reflower.com.cn/api/user/getUserInfo';
//const UPLOAD = 'https://i.reflower.com.cn/order/file/image/upload'
//const servicePage = 'https://i.reflower.com.cn/api/user/community/getpage'
//const loginurl = 'https://my.reflower.com.cn/login/tologin?redirecturi='
//const getdetail = 'https://i.reflower.com.cn/api/user/community/getdetail'

//process.env 环境变量
const USER        = process.env.USER;
const UPLOAD      = process.env.UPLOAD;
const servicePage = process.env.SERVICEPAGE;
const loginurl    = process.env.LOGINURL;
const getdetail   = process.env.GETDETAIL;

export default{
	//ordersUrl : API + '/order/list',                //订单列表
	loginurl : loginurl,
	// wechaturl: 'https://w-ce.reflower.com.cn?redirecturi=', //测试环境
	// alipayurl: 'https://my-ce.reflower.com.cn/login/aliauth?redirecturi=',
  wechaturl: 'https://w.reflower.com.cn?redirecturi=',  //正式环境
  alipayurl: 'https://my.reflower.com.cn/login/aliauth?redirecturi=',
	userInfo :  USER,
	upload   : UPLOAD,
	servicePage : servicePage,
	getdetail : getdetail,
  imgUrl:"https://img.reflower.com.cn/",
  alicart:"https://pay.reflower.com.cn/alipay/cart",
  wechatcart: "https://pay.reflower.com.cn/icbc/wechat/cartpay",//正式环境"https://pay.reflower.com.cn/ccbAggregatePay/wechat/cartpay",//"https://pay.reflower.com.cn/wechat/cartpay",//
  alicartGold:"https://pay.reflower.com.cn/alipay/H5/rechargePay",
  wechatcartGold: "https://pay.reflower.com.cn/icbc/wechat/H5/rechargePay",//"https://pay.reflower.com.cn/ccbAggregatePay/wechat/H5/rechargePay",
  goodUrl:"https://item.reflower.com.cn",
  url:"https://my.reflower.com.cn",
  tradeUrl:"https://trade.reflower.com.cn",
  // alicartGold:"https://pay-ce.reflower.com.cn/alipay/H5/rechargePay",
  // wechatcartGold: "https://pay-ce.reflower.com.cn/icbc/wechat/H5/rechargePay",
  // alicart:"https://pay-ce.reflower.com.cn/alipay/cart",
  // wechatcart: "https://pay-ce.reflower.com.cn/icbc/wechat/cartpay",//测试环境
    //  goodUrl:"https://item.reflower.com.cn",
    //  url:"https://my.reflower.com.cn",
    //  tradeUrl:"https://trade.reflower.com.cn"
}



// WEBPACK FOOTER //
// ./src/api.js